<template>
  <section class="bodypad">
    <SuccessBillMessage
      v-if="success"
      :style="success ? 'overflow: hidden' : ''"
    />

    <v-row v-else class="mt-4 mb-10 d-flex flex-column">
      <h6 class="text-h6 text-md-h5 font-weight-bold mb-6">Facturación</h6>
      <div class="left-col">
        <v-alert dense color="#FB8C00" icon="report_problem" type="warning">
          No pudimos verificar los datos de la factura, por favor cargalos
          manualmente a continuación.
        </v-alert>
        <v-row class="d-flex flex-column">
          <v-col v-if="formData.invoice">
            <h3 class="text-subtitle-1 text-md-h6 font-weight-bold">
              Factura cargada
            </h3>
            <v-card class="mt-6" elevation="0">
              <v-row class="d-flex align-center">
                <v-col cols="2" sm="2" md="1" class="py-0">
                  <v-icon
                    style="background-color: #d32f2f"
                    class="pa-2 rounded-lg"
                    color="white"
                    >description</v-icon
                  >
                </v-col>
                <v-col
                  cols="7"
                  sm="2"
                  md="8"
                  class="d-flex pa-0"
                  style="width: 100%"
                >
                  <v-card-text class="d-flex flex-column pa-0"
                    ><span
                      class="blue--text text--darken-2 font-weight-medium text-subtitle-1 text-md-h6 short-text"
                      style="cursor: pointer"
                      @click="openPDFInNewTab"
                      >{{ formData.invoice?.name }}</span
                    ></v-card-text
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col class="pt-6">
            <h3 class="text-subtitle-1 text-md-h6 font-weight-bold mb-2">
              Validar datos
            </h3>
            <v-form
              ref="invoiceForm"
              lazy-validation
              v-model="valid"
              @submit.prevent="handleSubmit"
            >
              <v-menu
                ref="menu"
                v-model="dateMenu"
                :close-on-content-click="false"
                :return-value.sync="formData.date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.date"
                    outlined
                    label="Fecha de la factura"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[(v) => !!v || 'Debe seleccionar una fecha']"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="formData.date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dateMenu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(formData.date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <div style="display: flex; align-items: center">
                <v-text-field
                  label="Punto de Venta"
                  outlined
                  style="max-width: 150px"
                  v-model="part1"
                  maxlength="5"
                  @blur="formatFirstPart"
                  :rules="[(v) => !!v || 'Campo requerido']"
                ></v-text-field>
                <span style="margin: 0 10px 25px">-</span>
                <v-text-field
                  label="Comprobante N°"
                  outlined
                  v-model="part2"
                  maxlength="8"
                  @blur="formatSecondPart"
                  :rules="[(v) => !!v || 'Campo requerido']"
                ></v-text-field>
              </div>
              <v-text-field
                label="CUIT"
                outlined
                v-model="formData.cuit"
                :rules="[(v) => !!v || 'Campo requerido']"
              ></v-text-field>
              <v-text-field
                label="Monto total"
                outlined
                prefix="$"
                v-model="formData.amount"
                :rules="[(v) => !!v || 'Campo requerido']"
              ></v-text-field>
              <v-btn
                type="submit"
                block
                depressed
                large
                color="blue darken-2 white--text"
                class="mt-1"
              >
                Enviar
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import SuccessBillMessage from "../components/SuccessBillMessage.vue";

export default {
  name: "AlternativeFormView",
  components: {
    SuccessBillMessage,
  },
  data() {
    return {
      dateMenu: false,
      valid: false,
      success: false,
      part1: "",
      part2: "",
    };
  },
  computed: {
    ...mapState("invoice", ["formData"]),

    formattedInvoiceNumber() {
      return `${this.part1}-${this.part2}`;
    },
  },
  methods: {
    ...mapActions("invoice", ["sendInvoice", "handleFormDataChanges"]),
    ...mapMutations("invoice", ["setState"]),

    parsePayload(formData = {}) {
      const { invoice, cbu, transactions, date, cuit, amount } = formData;
      const transactionIds = transactions.map((transaction) => transaction.id);

      const form = new FormData();
      form.append("archivo_factura", invoice);
      form.append("transacciones", transactionIds);
      form.append("cbu_field", cbu);
      form.append("fecha_factura", date);
      form.append("nro_factura", this.formattedInvoiceNumber);
      form.append("cuit_factura", cuit);
      form.append("monto_factura", amount);
      return form;
    },
    openPDFInNewTab() {
      if (this.formData?.invoice) {
        const blobUrl = URL.createObjectURL(this.formData.invoice);
        window.open(blobUrl, "_blank");
      }
    },
    async handleSubmit() {
      const isValid = this.$refs.invoiceForm.validate();

      if (isValid) {
        const newInvoice = this.parsePayload(this.formData);

        this.sendInvoice(newInvoice)
          .then(() => {
            this.$refs.invoiceForm.reset();
            this.success = true;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    formatFirstPart(event) {
      const value = event.target.value;
      let formattedNumber = value.replace(/[^0-9]/g, "");

      if (formattedNumber.length === 0) {
        this.part1 = '';
      } else if (formattedNumber.length < 4) {
        this.part1 = formattedNumber.padStart(5, "0");
      } else {
        this.part1 = formattedNumber.substring(0, 5);
      }
      this.showErrors = true;
    },
    formatSecondPart(event) {
      const value = event.target.value;
      let formattedNumber = value.replace(/[^0-9]/g, "");

      if(formattedNumber.length === 0) {
        this.part2 = '';
      } else if (formattedNumber.length < 8) {
        this.part2 = formattedNumber.padStart(8, "0");
      } else {
        this.part2 = formattedNumber.substring(0, 8);
      }
      this.showErrors = true;
    },
  },
  watch: {
    formData: {
      handler(newValue) {
        this.handleFormDataChanges(newValue);
      },
      deep: true,
    },
    success(newValue) {
      if (newValue) {
        this.setState();
        localStorage.removeItem('pending-transactions')
      }
    },
    "formData.cuit"(val) {
      if (val) {
        let isValid = /^([0-9]{2}-[0-9]{8}-[0-9]{1})$/g.test(val);
        if (!isValid) {
          this.formData.cuit = val.replace(/(\d{2})-?(\d{8})-?/g, "$1-$2-");
        }
      }
    },
    formattedInvoiceNumber(val) {
      if (val) {
        this.formData.invoiceNumber = val;
      } else {
        this.formData.invoiceNumber = null;
      }
    },
  },
};
</script>

<style>
.bodypad {
  padding: 12px 24px 108px 24px;
}
.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 959px) {
  .left-col {
    width: 100%;
  }
}

@media (min-width: 960px) {
  .left-col {
    width: 65%;
  }
}
</style>
